import { twMerge } from '@shared/themes';
import type { ComponentPropsWithoutRef } from 'react';

type StaticPageContentProps = ComponentPropsWithoutRef<'div'>;

/**
 * Vertical stack for the body of a static page.
 *
 * Holds the optional contents navigation and the numbered or unnumbered
 * sections that follow. Use this as the wrapper beneath {@link StaticPageHeader}.
 */
function StaticPageContent({ className, children, ...props }: StaticPageContentProps) {
  return (
    <div className={twMerge('flex flex-col', className)} {...props}>
      {children}
    </div>
  );
}

export { StaticPageContent, type StaticPageContentProps };
